import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f90d344e"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "welcome-carousel"
}
const _hoisted_2 = { class: "custom-header" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "main-title" }, [
  /*#__PURE__*/_createElementVNode("h2", null, "Getting Started")
], -1))
const _hoisted_4 = { class: "icon-section" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "dx-icon dx-icon-close" }, null, -1))
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = { class: "picture-carousel" }
const _hoisted_8 = { class: "picture-holder" }
const _hoisted_9 = ["src"]

import { computed } from "vue";
import DxGallery from "devextreme-vue/gallery";
import { IDDescriptionPair } from "@/types/generic/IDDescriptionPair";


export default /*#__PURE__*/_defineComponent({
  __name: 'home-carousel',
  props: {
  /**
   * The boolean value used with `v-model` to control the visibility or state of a modal or component.
   * @type {boolean}
   * @required
   */
  modelValue: {
    type: Boolean,
    required: true,
  },
},
  emits: [
  /**
   * Triggered when the `modelValue` changes. This is used to update the v-model variable in the parent component.
   * @property {boolean} value - Indicates whether the modal has been opened or closed.
   */
  "update:modelValue",
],
  setup(__props, { emit }) {

const props = __props;





const displayCarousel = computed({
  get: () => props.modelValue,
  set: (value: boolean) => emit("update:modelValue", value),
});

const carouselImages: IDDescriptionPair[] = [
  { id: 0, description: "../../../welcome/slide-1.gif" },
  { id: 1, description: "../../../welcome/slide-2.gif" },
  { id: 2, description: "../../../welcome/slide-3.gif" },
  { id: 3, description: "../../../welcome/slide-4.gif" },
];

return (_ctx: any,_cache: any) => {
  return (displayCarousel.value)
    ? (_openBlock(), _createElementBlock("section", _hoisted_1, [
        _createElementVNode("section", _hoisted_2, [
          _hoisted_3,
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", {
              class: "close-button-holder",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (displayCarousel.value = false))
            }, _hoisted_6)
          ])
        ]),
        _createElementVNode("section", _hoisted_7, [
          _createVNode(_unref(DxGallery), {
            id: "gallery",
            dataSource: carouselImages,
            loop: true,
            "show-nav-buttons": true,
            "show-indicator": true,
            width: "354",
            "item-template": "item"
          }, {
            item: _withCtx(({ data }) => [
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("img", {
                  src: data.description
                }, null, 8, _hoisted_9)
              ])
            ]),
            _: 1
          })
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})